module.exports = __webpack_public_path__ + "img/DSC_2655-xs.430f8240.png";